/**
 * Phase 8 T-18 §26.C — "Give feedback" text-only topbar button.
 *
 * Renders as a text-only 13 px button (zinc-600 / hover zinc-900).
 * Left of the bell icon in the Topbar.
 * Clicking opens <FeedbackModal />.
 */

import { useState } from 'react';
import { FeedbackModal } from './FeedbackModal';

export function FeedbackButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="hidden rounded-[6px] px-2 py-1 text-[13px] text-zinc-600 transition-colors hover:text-zinc-900 sm:inline-flex dark:text-zinc-400 dark:hover:text-zinc-100"
        aria-label="Give feedback"
        aria-haspopup="dialog"
      >
        Give feedback
      </button>

      <FeedbackModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
